import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="trix-readonly"
export default class extends Controller {
  static values = {
    enabled: Boolean
  }


  connect() {
    if (!this.enabledValue) return

    const trix = this.element.editor
    trix.element.setAttribute("contenteditable", "false")
    trix.toolbarElement?.remove()
  }
}
